import React from 'react';

const Loader = props => (
    <div
        id="loader"
        className={props.loaded ? 'loader-hide fadeOut' : 'loader-show fadeIn'}>
        <div className="loader" />
    </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.jsx